import { gql } from '@apollo/client';

export const CREATE_FINAL_EXAM = gql`
  mutation CreateFinalExam($createFinalExamInput: CreateFinalExamInput!) {
    createFinalExam(createFinalExamInput: $createFinalExamInput) {
      id
      userId
      tags
      userQuestions {
        questionId
        question {
          id
          prompt
          options {
            desc
            isAnswer
          }
          explanation
          tag
        }
        selectedOption {
          desc
          isAnswer
        }
      }
      isCompleted
      completedAt
      createdAt
      updatedAt
    }
  }
`;
